export default "__VITE_ASSET__2bcdeaaa__"